import { render, staticRenderFns } from "./chats.vue?vue&type=template&id=7a7cb8a3&"
import script from "./chats.vue?vue&type=script&lang=js&"
export * from "./chats.vue?vue&type=script&lang=js&"
import style0 from "./chats.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports